module.exports = __webpack_public_path__ + "static/media/Illus-Winter@3x.530e2d66.png";